var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullHeight" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "auto", persistent: "" },
          model: {
            value: _vm.humanDialogVisible,
            callback: function ($$v) {
              _vm.humanDialogVisible = $$v
            },
            expression: "humanDialogVisible",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "mx-auto" },
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.humanDialogTitle))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-6 pr-6" },
                [
                  _c("v-checkbox", {
                    attrs: { color: "primary" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("span", [_vm._v(_vm._s(_vm.humanCheckboxText))]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.userIsHuman,
                      callback: function ($$v) {
                        _vm.userIsHuman = $$v
                      },
                      expression: "userIsHuman",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      class: _vm.textColourCss,
                      attrs: { color: "primary" },
                      on: { click: _vm.onConfirmHuman },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.btnConfirmText) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("cookie-snackbar", {
        attrs: {
          cookieManager: _vm.cookieManager,
          show: _vm.showCookieSnackbar,
          text: _vm.cookiePolicyText,
          acceptText: _vm.$vuetify.lang.t("webmap.buttonText.cookieAccept"),
          cancelText: _vm.$vuetify.lang.t("webmap.buttonText.cookieCancel"),
        },
      }),
      _vm._v(" "),
      _c(
        "v-app-bar",
        {
          attrs: {
            fixed: "",
            app: "",
            dark: !_vm.useDarkText,
            "clipped-left": "",
            color: "primary",
          },
        },
        [
          _c("v-app-bar-nav-icon", {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.showMenu.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("v-toolbar-title", { class: _vm.$store.getters["textCssClass"] }, [
            _vm._v(_vm._s(_vm.menuTitle)),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("home-button"),
          _vm._v(" "),
          _c("toolstrip"),
          _vm._v(" "),
          _c("speed-dial"),
          _vm._v(" "),
          _c("culture-selector"),
          _vm._v(" "),
          _c("profile"),
        ],
        1
      ),
      _vm._v(" "),
      _c("navigation-drawer", { attrs: { app: "", cssClass: "appNavDrawer" } }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            width: "unset",
            fullscreen: _vm.isMobile,
            "retain-focus": false,
          },
          model: {
            value: _vm.showInitialDialog,
            callback: function ($$v) {
              _vm.showInitialDialog = $$v
            },
            expression: "showInitialDialog",
          },
        },
        [_c("router-view", { attrs: { name: "dialogView" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _vm.resizeHandler,
              expression: "resizeHandler",
            },
          ],
          attrs: { tag: "div", app: "", fluid: "" },
        },
        [
          _c("activity-snackbar"),
          _vm._v(" "),
          _c("error-snackbar"),
          _vm._v(" "),
          _c("notification-snackbar"),
          _vm._v(" "),
          _c("interactive-snackbar"),
          _vm._v(" "),
          _c("div", {
            staticClass: "vuetifyMapContainer",
            attrs: { id: _vm.mapContainerId },
          }),
          _vm._v(" "),
          _c(
            "application-side-panel",
            {
              class: _vm.appSidePanelClass,
              attrs: {
                id: "appSidePanel",
                "content-class": "appSidePanel_content background-colour",
                position: "left",
              },
              on: { transitionComplete: _vm.transitionCompleteHandler },
            },
            [
              _c(
                "v-fade-transition",
                { attrs: { mode: "out-in" } },
                [
                  _c("router-view", {
                    attrs: {
                      name: "appPanelView",
                      visible: _vm.appPanelVisible,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("application-controls"),
          _vm._v(" "),
          _vm._l(_vm.panels, function (panel, index) {
            return _c(panel, { key: index, tag: "component" })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }